<script setup>
import {toRefs, computed} from 'vue'

const emit = defineEmits([
  'click',
])
const props = defineProps({
  isClickable: {
    type: Boolean,
    default: false,
  },
  justify: {
    type: String,
    default: 'start',
  },
  isHeaderCell: {
    type: Boolean,
    default: false,
  },
  scope: {
    type: String,
    default: 'row',
  },
})

//Get refs
const {isClickable, isHeaderCell} = toRefs(props)

//Computed properties for automated header cell behavior
const tag = computed(() => isHeaderCell.value ? 'th' : 'td')

//Handle click event
const handleClick = event => {
  if (isClickable.value) {
    emit('click', event)
  }
}
</script>
<template>
  <component
    v-bind="$attrs"
    :is="tag"
    :class="{
      [$style.cell]: true,
      [$style.clickable]: isClickable,
      [$style[justify]]: !!justify,
    }"
    :tabindex="isClickable ? 0 : -1"
    :scope="isHeaderCell ? scope : undefined"
    @click="handleClick($event)"
    @keydown.enter.prevent="handleClick($event)"
    @keydown.space.prevent="handleClick($event)"
  >
    <div :class="$style.contents">
      <slot />
      <div
        v-if="$slots.icons"
        :class="$style.icons"
      >
        <slot name="icons" />
      </div>
    </div>
  </component>
</template>

<style module lang="scss">
.cell {
  padding: 0.75rem 0.5rem;
  vertical-align: middle;
  transition: background-color .1s ease;
  border-bottom: 1px solid var(--color-borders-light);
  font-weight: 300; // Override browser default bold for th elements

  &:not(:last-child) {
    padding-right: 1rem;
  }
  &.start {
    text-align: left;
  }
  &.center {
    text-align: center;
  }
  &.end {
    text-align: right;
  }
  &.clickable {
    cursor: pointer;
  }
}
.contents {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
}
.icons {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  color: var(--light-gray);
}
</style>
